import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, concatMap, forkJoin, map, mergeMap, of, tap } from 'rxjs';
import { NgrxService } from 'src/app/services';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services';
import firebase from 'firebase/compat/app';
@Injectable({
	providedIn: 'root',
})
export class HubbleService {
	constructor(
		private httpService: HttpClient,
		private ngrxService: NgrxService,
		private authService: AuthService,
	) {}

	initAllCommunity() {
		this.ngrxService.init('hubble', 'community');
	}

	loadAllCommunity() {
		return this.getAllCommunities().pipe(
			tap((data: any) => {
				this.ngrxService.loadInitData('hubble', 'community', data);
			}),
		);
	}

	fetchAllCommunity() {
		return this.ngrxService.loadData('hubble', 'community');
	}

	getAllCommunities() {
		return this.httpService.post(
			environment.url.lookupBaseUrl +
				'api/lookup/typesense/search/allCommunities',
			{},
		);
	}

	addCommunity(communityInfo: any, email: any) {
		return this.getIdbyEmail(email).pipe(
			mergeMap(({ firebaseId }: any) =>
				this.httpService
					.post(
						environment.url.lookupBaseUrl +
							'api/lookup/create-community-tokenless',
						{ ...communityInfo, user_id: firebaseId },
					)
					.pipe(
						tap((data: any) => {
							this.loadAllCommunity().subscribe();
						}),
					),
			),
		);
	}

	getIdbyEmail(email: any) {
		return this.httpService
			.get(environment.url.hubble + '/get/firebaseId/' + email)
			.pipe(
				tap((data: any) => {
					if (!data.firebaseId) {
						throw new Error('Email does not exist : ' + email);
					}
				}),
				catchError((err: any): any => {
					this.authService.addToastMsg(err);
				}),
			);
	}

	getEmailById(id: any) {
		return this.httpService.get(
			`${environment.url.hubble}/get/email/firebase/${id}`,
		);
	}

	//Events

	async fetchAllEvents(
		pageNo: any,
		pageSize: any,
		timeFrame: any,
		searchValue: any = '',
	) {
		const fb = firebase;
		const token = await fb.auth()?.currentUser?.getIdToken();

		const search = searchValue ? `&title_search=${searchValue}` : '';

		const eventType = timeFrame == 'upcoming' ? 1 : 5;
		return fetch(
			environment.url.feedBaseUrl +
				`posts/get-all-events?page_no=${pageNo}&page_size=${pageSize}` +
				search,
			{
				method: 'POST',
				body: JSON.stringify(this.getAuthBodyNew(eventType)),
				headers: {
					'Content-type': 'application/json; charset=UTF-8',
					Authorization: 'Bearer ' + token,
				},
			},
		);
	}

	addEvent(event: any, email: any) {
		let emails = [];
		emails.push(this.getIdbyEmail(email));
		if (event.speakerEmail) {
			const speaker$ = this.getIdbyEmail(event.speakerEmail);
			emails.push(speaker$);
		}
		if (event.moderatorEmail) {
			const moderator$ = this.getIdbyEmail(event.moderatorEmail);
			emails.push(moderator$);
		}

		return forkJoin(emails).pipe(
			mergeMap((data: any) => {
				console.log(data, 'fork join data');
				return this.httpService.post(
					environment.url.feedBaseUrl + 'posts/create-event',
					{
						...event,
						user_id: data[0].firebaseId,
					},
				);
			}),
		);
	}

	editEvent(event: any, email: any) {
		let emails = [];
		emails.push(this.getIdbyEmail(email));
		if (event.speakerEmail) {
			const speaker$ = this.getIdbyEmail(event.speakerEmail);
			emails.push(speaker$);
		}
		if (event.moderatorEmail) {
			const moderator$ = this.getIdbyEmail(event.moderatorEmail);
			emails.push(moderator$);
		}

		return forkJoin(emails).pipe(
			mergeMap((data: any) => {
				console.log(data, 'fork join data');
				return this.httpService.post(
					environment.url.feedBaseUrl + 'posts/edit-event',
					{
						...event,
						user_id: data[0].firebaseId,
					},
				);
			}),
		);
	}

	cancelEvent(event: any) {
		return this.httpService.post(
			environment.url.feedBaseUrl + 'posts/cancel-event-tokenless',
			event,
		);
	}

	deleteEvent(event: any) {
		return this.httpService.post(
			environment.url.lookupBaseUrl + 'api/lookup/delete-post-tokenless',
			event,
		);
	}

	addEventRecording(event: any) {
		return this.httpService.post(
			environment.url.feedBaseUrl + 'posts/add-edit-recording-url-tokenless',
			event,
		);
	}

	initEventTag() {
		this.ngrxService.init('event', 'tags');
	}

	initEventTagApi() {
		return this.getEventTag().pipe(
			tap((data: any) => {
				let tags = [];
				console.log(data);
				if (data) {
					tags = data
						.filter((e: any) => e.id === 4)
						.map((e: any) => e.values)[0];
				}
				this.ngrxService.loadInitData('event', 'tags', tags);
			}),
		);
	}

	getEventTag() {
		return this.httpService.get(environment.url.hubble + '/tagGroups/filtered');
	}

	loadEventTags() {
		return this.ngrxService.loadData('event', 'tags');
	}

	initEventType() {
		this.ngrxService.init('event', 'types');
	}

	initEventTypeApi() {
		return this.getEventTypes().pipe(
			tap((ev: any) => this.ngrxService.loadInitData('event', 'types', ev)),
		);
	}

	fetchEventTypes() {
		return this.ngrxService.loadData('event', 'types');
	}

	getEventTypes() {
		return this.httpService.get(
			environment.url.feedBaseUrl + 'posts/get-event-categories',
		);
	}

	getAuthBody() {
		const current = new Date();
		const year = current.getFullYear();
		const month = current.getMonth() + 1;
		const day = current.getDate();
		const date = year + '-' + month + '-' + day;
		const currTime = current.toLocaleTimeString([], {
			hour: '2-digit',
			minute: '2-digit',
			timeZone: 'UTC',
		});
		return { get_events: 1, date: date, time: currTime };
	}

	getAuthBodyNew(type: number) {
		const current = new Date();
		const year = current.getFullYear();
		const month = current.getMonth() + 1;
		const day = current.getDate();
		const date = year + '-' + month + '-' + day;
		const currTime = current.toLocaleTimeString([], {
			hour: '2-digit',
			minute: '2-digit',
			timeZone: 'UTC',
		});
		return { get_events: type, date: date, time: currTime };
	}

	deploy() {
		return this.httpService
			.get(
				'https://api.vercel.com/v1/integrations/deploy/prj_IOAl8wPgxyBX2VKbkkIspysaBYUw/rdPxMJtGCZ',
			)
			.pipe(
				catchError((err: any, caught) => {
					this.authService.addToastMsg(
						'Deployment failed, please contact tech team',
					);
					return of();
				}),
			);
	}
}
